import { handleAction, handleActions } from "redux-actions";
import { v4 as uuidv4 } from "uuid";

import questionReducers from "redux/questions/reducers";
import {
    checkinSetAnswer,
    checkinRemoveAnswer,
    checkinReset,
    checkinResetAnswers,
    checkinSetNudged,
} from "./actions";

export default {
    // Object of answers, key = question id
    answers: handleActions(
        {
            [checkinSetAnswer]: (state, { payload }) => ({
                ...state,
                [payload.question_id]: payload,
            }),
            [checkinRemoveAnswer]: (state, { payload: questionID }) => {
                const newState = { ...state };
                delete newState[questionID];
                return newState;
            },
            [checkinResetAnswers]: () => null,
        },
        {},
    ),
    company: (state = {}) => state,
    retain_paid: (state = false) => state,
    nudged: handleAction(checkinSetNudged, (state, { payload }) => payload, false),
    settings: (state = false) => state,
    questions: questionReducers,
    isKiosk: (state = false) => state,
    kioskHireUUID: handleAction(checkinReset, () => uuidv4(), uuidv4()),
    is_preview: (state = false) => state,
    checkin_type: (state = null) => state,
    is_demo: (state = false) => state,
};
